module.exports = "<div class=\"c-help\">\n    <text-cheatsheet ng-if=\"$ctrl.helptype === 'markdown'\"></text-cheatsheet>\n    <period-cheatsheet ng-if=\"$ctrl.helptype === 'period'\"></period-cheatsheet>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/base/views/help.area.html
// module id = 385
// module chunks = 0